import ListGroupAgent from '@/views/dashboard-courier/components/ListGroupAgent.vue'
import TableListTrackingCourier from '@/views/dashboard-courier/components/TableListTrackingCourier.vue'

export default {
  name: 'DashboardCourier',
  components: {
    ListGroupAgent,
    TableListTrackingCourier
  }
}